
export default{
  login: ({commit})=>{
    commit("login")
  },
	logout: ({commit})=>{
		commit("logout")
	}
}



// WEBPACK FOOTER //
// ./src/store/actions.js